import React, { useState } from "react";
import AgentMarkup from "../_dashboard/AgentMarkup/AgentMarkup";
import { Dialog, DialogContent } from "@material-ui/core";

const EXAMPLE_BASE_PRICE = 5000;

const AgentMarkupDialog = ({ setOpenBookingModal, openBookingModal }) => {
  const [amount, setAmount] = useState("");

  const handleClose = () => {
    setOpenBookingModal(false);
  };

  const markup = Number(amount) || 0;
  const customerPrice = EXAMPLE_BASE_PRICE + markup;

  return (
    <Dialog
      open={openBookingModal}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 16,
          boxShadow: "none",
        },
        elevation: 0,
      }}
      BackdropProps={{
        style: { backgroundColor: "rgba(0,0,0,0.4)" },
      }}
    >
      {/* Header */}
      <div className="flex items-center justify-between px-5 pt-5 pb-3">
        <div>
          <p className="text-lg font-bold text-gray-800 mb-0">Agent Markup</p>
          <p className="text-sm text-gray-500 mb-0">
            Set your commission on flight bookings
          </p>
        </div>
        <button
          onClick={handleClose}
          className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 hover:text-gray-700 transition-colors"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>

      <DialogContent className="!px-5 !pb-5 !pt-0">
        {/* Live Preview Card */}
        <div className="bg-blue-50 border border-blue-100 rounded-xl p-4 mb-4">
          <p className="text-xs font-bold text-blue-600 uppercase tracking-wide mb-3">
            Live Preview
          </p>

          {/* Base price row */}
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm text-gray-500 flex items-center gap-1">
              ✈️ Base Flight Price
            </span>
            <span className="text-sm font-semibold text-gray-700">
              ₹{EXAMPLE_BASE_PRICE.toLocaleString()}
            </span>
          </div>

          {/* Markup row */}
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm text-orange-500 flex items-center gap-1">
              📈 Your Markup
            </span>
            <span className="text-sm font-semibold text-orange-500">
              + ₹{markup.toLocaleString()}
            </span>
          </div>

          <hr className="border-dashed border-blue-200 my-2" />

          {/* Customer pays row */}
          <div className="flex justify-between items-center mb-3">
            <span className="text-sm font-semibold text-gray-700">
              Customer Pays
            </span>
            <span className="text-base font-bold text-gray-800">
              ₹{customerPrice.toLocaleString()}
            </span>
          </div>

          {/* Commission highlight */}
          <div className="bg-green-100 rounded-lg px-3 py-2 flex justify-between items-center">
            <span className="text-sm font-semibold text-green-800">
              💰 Your Commission
            </span>
            <span className="text-base font-bold text-green-700">
              ₹{markup.toLocaleString()}
            </span>
          </div>

          <p className="text-xs text-gray-400 mt-2 mb-0">
            * Example based on ₹{EXAMPLE_BASE_PRICE.toLocaleString()} flight. Actual prices vary.
          </p>
        </div>

        {/* Markup Form */}
        <AgentMarkup
          handleClose={handleClose}
          amount={amount}
          setAmount={setAmount}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AgentMarkupDialog;
